"use strict";

const wishlist_items = JSON.parse(
  localStorage.getItem("glozin__wishlist-items")
);
const wishlistDiv = document.querySelector(".wishlist-page-main");
var WishlistPageShopify = (function () {
  return {
    initWishlistItems: function () {
      if (window.location.search.indexOf("page=") == -1) {
        this.init();
      }
    },

    init: function () {
      const _this = this;
      if (wishlistDiv) {
        const div_no_product = wishlistDiv.querySelector(
          ".wishlist-no-product-js"
        );
        if (wishlist_items === null || wishlist_items.length === 0) {
          _this.skeletonFunction(0);
          div_no_product.classList.remove("hidden");
        } else {
          var query = "";
          wishlist_items.forEach((e, key, wishlist_items) => {
            if (!Object.is(wishlist_items.length - 1, key)) {
              query += e + "%20OR%20id:";
            } else {
              query += e;
            }
          });
          const section_id = document.querySelector(".wishlist-page-section")
            .dataset.sectionId;
          var productAjaxURL =
            "?section_id=" +
            section_id +
            "&type=product&options[unavailable_products]=last&q=id:" +
            query;

          fetch(`${window.routes.search_url}${productAjaxURL}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = parser.parseFromString(responseText, "text/html");
              const row = document.createElement("div");
              row.classList.add("wishlist-list-items");
              const exist_row = wishlistDiv.querySelector(
                ".wishlist-list-items"
              );
              if (exist_row) {
                exist_row.remove();
              }
              const er = html.querySelector(
                ".wishlist-page-main .wishlist-list-items"
              );
              if (wishlist_items.length !== 0 && er) {
                wishlistDiv.innerHTML = html.querySelector(
                  ".wishlist-page-main"
                ).innerHTML;
                _this.skeletonFunction(700);
                _this.addRemoveEventListeners(); // Ajout des événements pour suppression
              } else {
                _this.skeletonFunction(0);
                div_no_product.classList.remove("hidden");
              }
              _this.mergeItems();
            })
            .catch((e) => {
              console.error(e);
            })
            .finally((e) => {
              initLazyloadItem();
            });
        }
      }
    },

    mergeItems: function () {
      const arr = [];
      if (wishlistDiv) {
        wishlistDiv
          .querySelectorAll(".product-item__action button-wishlist")
          .forEach((e) => {
            arr.push(e?.dataset.productId);
          });
      }
      localStorage.setItem("glozin__wishlist-items", JSON.stringify(arr));
      this.addRemoveEventListeners(); // Ajout des événements pour suppression
    },

    removeFromWishlist: function (productId) {
      // Récupère les éléments de la wishlist
      let wishlist_items = JSON.parse(localStorage.getItem("glozin__wishlist-items"));

      // Vérifie si la liste existe et supprime le produit correspondant
      if (wishlist_items && wishlist_items.includes(productId)) {
        wishlist_items = wishlist_items.filter((item) => item !== productId);
        localStorage.setItem("glozin__wishlist-items", JSON.stringify(wishlist_items));

        // Retire visuellement l'élément de la page
        const productElement = document.querySelector(
          `[data-product-id="${productId}"]`
        );
        if (productElement) {
          productElement.remove();
        }

        // Vérifie s'il n'y a plus de produits et affiche un message
        const div_no_product = document.querySelector(".wishlist-no-product-js");
        if (wishlist_items.length === 0 && div_no_product) {
          div_no_product.classList.remove("hidden");
        }
      }
    },

    addRemoveEventListeners: function () {
      const removeButtons = document.querySelectorAll(".wishlist-remove-btn");
      removeButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          const productId = button.dataset.productId; // Assure-toi que chaque bouton a un `data-product-id`
          this.removeFromWishlist(productId);
        });
      });
    },

    skeletonFunction: function (timer) {
      window.setTimeout(function () {
        if (this.document.querySelector("skeleton-page")) {
          this.document.querySelector("skeleton-page").remove();
        }
        if (this.document.querySelector(".wishlist-page-section-inner")) {
          this.document
            .querySelector(".wishlist-page-section-inner")
            .classList.remove("hidden");
        }
      }, timer);
    },
  };
})();
WishlistPageShopify.initWishlistItems();